/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AgentCreateChatRequest {
    getFixupPrototypeFunction() { return AgentCreateChatRequest.fixupPrototype; }

    static newInstance(model: Partial<AgentCreateChatRequest>): AgentCreateChatRequest {
        let obj = Object.assign(new AgentCreateChatRequest(), model);
        AgentCreateChatRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AgentCreateChatRequest>): AgentCreateChatRequest {
        if (!model) return null;
        return AgentCreateChatRequest.newInstance(<AgentCreateChatRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AgentCreateChatRequest) {
        if (!obj) return;

        models.AgentCreateChatRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AgentCreateChatRequest): boolean {
        Object.setPrototypeOf(obj, AgentCreateChatRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Name of the chat
     */
    name: string;

    /**
     * ID of the agent
     */
    agent_id: string;

    /**
     * ID of the tenant
     */
    tenant_id: string;

}
